import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOfferDetail } from "src/models/Offers/Offer.models";

interface OfferDetailState {
  offerDetails: IOfferDetail[];
  offerDetailToEdit: IOfferDetail | null;
}

const initialState: OfferDetailState = {
  offerDetails: [],
  offerDetailToEdit: null,
};

const OfferDetailSlice = createSlice({
  name: "OfferDetail",
  initialState,
  reducers: {
    setOfferDetailList: (state, action: PayloadAction<IOfferDetail[]>) => {
      state.offerDetails = action.payload;
    },
    concatListOfferDetail: (
      state: OfferDetailState,
      action: PayloadAction<IOfferDetail[]>
    ) => {
      state.offerDetails = [...state.offerDetails.concat(action.payload)];
    },
    setOfferDetailToEdit: (
      state,
      action: PayloadAction<IOfferDetail | null>
    ) => {
      state.offerDetailToEdit = action.payload;
    },
    addOfferDetail: (state, action: PayloadAction<IOfferDetail>) => {
      state.offerDetails.push(action.payload);
    },
    updateOfferDetail: (state, action: PayloadAction<IOfferDetail>) => {
      let itemIndex = state.offerDetails.findIndex(
        item => item.offerDetailId === action.payload.offerDetailId
      );
      if (itemIndex !== -1) state.offerDetails[itemIndex] = action.payload;
    },
    deleteOfferDetail: (state, action: PayloadAction<number>) => {
      const newArray = state.offerDetails.filter(
        item => item.offerDetailId !== action.payload
      );
      state.offerDetails = newArray;
    },
  },
});

export const {
  setOfferDetailList,
  concatListOfferDetail,
  setOfferDetailToEdit,
  addOfferDetail,
  updateOfferDetail,
  deleteOfferDetail,
} = OfferDetailSlice.actions;

export default OfferDetailSlice.reducer;
